export const SES_AUTH_ACCESS_KEYS = "access_keys";
export const SES_AUTH_IAM_ROLE = "iam_role";

export function isSesIamRoleMode(providerConfig) {
  if (!providerConfig || typeof providerConfig !== "object") {
    return false;
  }
  return String(providerConfig.auth_mode || "").trim().toLowerCase() === SES_AUTH_IAM_ROLE;
}

export function sesShowsCredentialFields(provider, providerConfig) {
  if (provider !== "ses") {
    return true;
  }
  return !isSesIamRoleMode(providerConfig);
}
